import React from 'react';
import css from './index.module.scss';
import { KfcBucket, Lightning } from '../../../components/Icons';
import Button from '@material-ui/core/Button';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import CountDown from '../../../components/CountDown';
import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage } from 'react-intl';
import BackButton from '../../../components/BackButton';
const { selectCurrentCountry } = Slices.profileSlice;
const { useSelector } = Redux;
const { selectCountryValidations } = Slices.configSlice;
const LightningPayTimer = ({ onClose, postOrderHandler, cart, timerDuration }) => {
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations && countryValidations.currency;

  return (
    <div className={css.root}>
      <div className={css.modalTitle}>
        <div>
          <FormattedMessage id="lightning_pay_timer_title" />
        </div>
        <div className={css.containerModal}>
          <BackButton type="cross" handleBack={onClose} />
        </div>
      </div>

      <div className={css.timerSection}>
        <div className={css.icon}>
          <Lightning />
        </div>
        <div className={css.text}>
          <span>Lightning Pay</span>
          <FormattedMessage id="lightning_pay_timer_description" />
        </div>
        <CountDown onComplete={() => postOrderHandler(null, null, true)} duration={timerDuration} />
      </div>

      <div className={css.footerSection}>
        <div className={css.priceSection}>
          <div className={css.price}>{`${decimalChecker(cart.cartValue)} ${currency || ''}`}</div>
          <div className={css.text}>
            <FormattedMessage id="lightning_pay_order_total" />
          </div>
        </div>
        <Button className={css.cancelButton} variant="contained" color="primary" onClick={onClose}>
          <FormattedMessage id="cancel" />
        </Button>
      </div>
    </div>
  );
};

export default LightningPayTimer;
